import {createSlice} from '@reduxjs/toolkit'

const initialState = { 
    isLoading:false,
    loadedEvent: false,
    loadingEvent: false,
    loadingContent: "Loading Please Wait",
    upcomingEvent:"",
    duplicateEvent: null,
    error:"" 
}

const upcomingEventSlice = createSlice({
    name:"upcoming-event",
    initialState,
    reducers:{
        upcomingEventLoading:(state) => {
            state.isLoading = true
        },
        upcomingEventItemList:(state, {payload}) => {
            state.upcomingEvent = payload
            state.isLoading = false
        },
        upcomingEventError:(state, {payload}) => {
            state.error = payload
        },
        setLoadedEvent: (state, {payload}) => {
            state.loadedEvent = payload
        },
        setLoadingEvent: (state, {payload}) => {
            state.loadingEvent = payload
        },
        setLoadingContent: (state, {payload}) => {
            state.loadingContent = payload
        },
        setDuplicateEvent: (state, {payload}) => {
            state.duplicateEvent = payload
        }
    }
})

export const { 
    upcomingEventLoading,
    upcomingEventItemList,
    upcomingEventError,
    setLoadedEvent,
    setLoadingEvent,
    setLoadingContent,
    setDuplicateEvent
} = upcomingEventSlice.actions
export default upcomingEventSlice.reducer